import { redirectToIdpLogout } from "_helpers/utils/idp";
import axios, { type AxiosError } from "axios";
import type { Login } from "models/auth/Login";
import { type ApiRequestError, RequestError } from "models/error/Error";
import cookieStorage from "persistence";
import { clearCookiesLogout, clearUsetifulUserDataOnLogout } from "persistence/access";
import { handlingResponse, logError } from "repositories/utils";

const validateLoginUser = async (code = ""): Promise<Login> => {
  try {
    const result = await axios.post("/api/validate", { code });
    return handlingResponse<Login>([200], "Error validating code")(result);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new RequestError({ message, status, type: "validateUserLoginFailed" });
  }
};

// Trigger a request to verify if current access token remains valid
const verifyAccessToken = async (): Promise<string> => {
  try {
    const result = await axios.get("/api/accounts/verify-access-token", {
      headers: { Authorization: cookieStorage.getToken() },
    });
    return handlingResponse<string>([200], "Session token validation failed")(result);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new RequestError({ message, status, type: "validateUserTokenFailed" });
  }
};

const logout = (): void => {
  clearCookiesLogout();
  clearUsetifulUserDataOnLogout();
  redirectToIdpLogout();
};

export { validateLoginUser, verifyAccessToken, logout };
